// extracted by mini-css-extract-plugin
export default {"groupHeaderContainer":"group-header-module__groupHeaderContainer--FgusJ","groupHeaderContent":"group-header-module__groupHeaderContent--fWM4g"};